import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { mediaDetailData, mediaDetailModel } from '@nrwl/rx-models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { RxIconComponent } from 'libs/rx-ui/src/lib/rx-icon/rx-icon.component';
import { DateFormatPipe } from 'libs/rx-form-builder/src/lib/helpers/date-format.pipe';
import { StringReplacerPipe } from 'libs/rx-pipes/src/lib/string-replacer.pipe';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';

@Component({
  selector: 'rx-media-detail',
  templateUrl: './rx-media-detail.component.html',
  styleUrls: ['./rx-media-detail.component.scss'],
  imports: [CommonModule, RxIconComponent, DateFormatPipe, StringReplacerPipe, PinchZoomComponent],
})
export class RxMediaDetailComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  public images: mediaDetailModel[] | any;
  public currentImage: mediaDetailModel | any;
  public currentIndex: number | any;
  public expandNotes = false;
  public showControls = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: mediaDetailData,
    private mediaDialog: MatDialogRef<RxMediaDetailComponent>,
  ) {}

  ngOnInit(): void {
    this.images = this.data.items;
    this.currentIndex = this.data.currentIndex;
    this.currentImage = this.images[this.currentIndex];
  }

  cancel(): void {
    this.mediaDialog.close();
  }

  toggleShowControls() {
    this.showControls = !this.showControls;
  }

  public videoActions(event) {
    if (event.type === 'pause') this.showControls = true;
    if (event.type === 'playing') this.showControls = false;
  }

  showNextItem(): void {
    if (this.currentIndex === this.images.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = this.currentIndex + 1;
    }
    this.currentImage = this.images[this.currentIndex];
  }

  showPreviousItem(): void {
    if (this.currentIndex === 0) {
      this.currentIndex = this.images.length - 1;
    } else {
      this.currentIndex = this.currentIndex - 1;
    }
    this.currentImage = this.images[this.currentIndex];
  }

  toggleExpandNotes(): void {
    this.expandNotes = !this.expandNotes;
  }

  toggleVideo() {
    this.videoplayer.nativeElement.play();
  }
}
